import { render, staticRenderFns } from "./item-area-badges.vue?vue&type=template&id=6273b928&"
import script from "./item-area-badges.vue?vue&type=script&lang=js&"
export * from "./item-area-badges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports